import { computed, type ComputedRef } from 'vue';
import type { useCompanyStore } from '@Stores/company.store';
import type { useDashboardStore } from '@Stores/dashboard.store';

/**
 * Builds a reactive logo URL that includes the active deal's locationId.
 * Follows the Location → Brand → Company specificity chain via the
 * GetLogo endpoint's server-side fallback.
 */
export default function useDealLogoUrl(
    companyImageBaseUrl: string,
    companyStore: ReturnType<typeof useCompanyStore>,
    dashboardStore: ReturnType<typeof useDashboardStore>,
): ComputedRef<string> {
    return computed(() => {
        if (!companyStore.company) return '';

        const base = companyImageBaseUrl.endsWith('/')
            ? companyImageBaseUrl.slice(0, -1)
            : companyImageBaseUrl;

        const url = `${base}/api/Company/GetLogo/${companyStore.company.id}`;

        const params = new URLSearchParams();
        const locationId = dashboardStore.activeDeal?.locationId;
        if (locationId) params.append('locationId', locationId);
        if (companyStore.brand?.id) params.append('brandId', companyStore.brand.id);
        const query = params.toString();

        return query ? `${url}?${query}` : url;
    });
}
